import { useState } from 'react';
import { Menu as MenuIcon, X } from 'lucide-react';
import { Link, useRoute } from '@/router';
import { NAV } from '@/data/site';
import { GonjongMark } from '@/components/Motifs';

export default function Header() {
  const { path } = useRoute();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-stone-200/80 bg-santan/90 backdrop-blur-md">
      <a
        href="#konten-utama"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-crimson focus:px-4 focus:py-2 focus:text-santan"
      >
        Langsung ke konten utama
      </a>
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link to="/" className="flex items-center gap-3 text-crimson" data-testid="nav-logo-link">
          <GonjongMark className="h-9 w-9 shrink-0" />
          <span className="leading-tight">
            <span className="block text-[10px] font-semibold uppercase tracking-[0.28em] text-stone-500">Nasi Padang</span>
            <span className="block font-display text-xl font-bold tracking-tight text-charcoal">Sederhana</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="Navigasi utama">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, '-')}-link`}
              aria-current={path === n.to ? 'page' : undefined}
              className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-200 ${
                path === n.to ? 'bg-turmeric-soft text-crimson' : 'text-stone-600 hover:bg-cream-2 hover:text-charcoal'
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/menu/"
            data-testid="header-cta-menu"
            className="hidden rounded-full bg-crimson px-5 py-2.5 text-sm font-bold text-santan shadow-sm transition-colors duration-200 hover:bg-crimson-dark md:inline-block"
          >
            Jelajahi Menu
          </Link>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            aria-expanded={open}
            aria-controls="menu-seluler"
            aria-label={open ? 'Tutup menu navigasi' : 'Buka menu navigasi'}
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-stone-300 text-charcoal transition-colors duration-200 hover:bg-cream-2 md:hidden"
          >
            {open ? <X className="h-5 w-5" aria-hidden="true" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" />}
          </button>
        </div>
      </div>

      {open && (
        <nav id="menu-seluler" className="border-t border-stone-200 bg-santan px-4 pb-6 pt-2 md:hidden" aria-label="Navigasi seluler" data-testid="mobile-nav-panel">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, '-')}-link`}
              aria-current={path === n.to ? 'page' : undefined}
              className={`mt-1 block rounded-xl px-4 py-3.5 text-base font-semibold transition-colors duration-200 ${
                path === n.to ? 'bg-turmeric-soft text-crimson' : 'text-stone-700 hover:bg-cream-2'
              }`}
            >
              {n.label}
            </Link>
          ))}
          <Link
            to="/menu/"
            onClick={() => setOpen(false)}
            data-testid="mobile-cta-menu"
            className="mt-3 block rounded-full bg-crimson px-5 py-3.5 text-center text-base font-bold text-santan"
          >
            Jelajahi Menu
          </Link>
        </nav>
      )}
    </header>
  );
}
